<template>
  <div class="h-auto w-screen p-4">
    <br />
    <textarea
      id="jsonSettings"
      class="my-5 w-screen max-w-xl p-3 text-base rounded-lg shadow-lg border-black"
      style="min-height: 650px"
      v-model="JSONData"
    />
    <br />
    <json-editor v-model="JSONData" />
    <vs-button @click="save"> Save </vs-button>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import JsonEditor from 'vue-json-edit';
export default {
  data() {
    return {
      JSONData: '',
    };
  },
  components: {
    JsonEditor,
  },
  props: ['slug'],
  methods: {
    ...mapActions('eCommerce', ['saveJsonSettings', 'getJsonSettings']),
    save() {
      // JSON.parse sits outside the promise chain below, so a syntax error here
      // - including the empty textarea you get for a slug with no document yet -
      // would throw past the .catch() and leave the admin with no notification
      // at all, success or failure.
      let value;
      try {
        value = JSON.parse(this.JSONData);
      } catch (err) {
        this.$vs.notify({
          title: 'Invalid JSON',
          text: 'Please check the settings JSON and try again.',
          color: 'danger',
        });
        return;
      }
      const slug = this.slug;
      this.saveJsonSettings({ value, slug })
        .then(() => {
          this.$vs.notify({
            title: 'Success',
            text: 'Settings Saved.',
            color: 'success',
          });
        })
        .catch((err) => {
          this.$vs.notify({
            title: 'Failed to save settings.',
            text: 'Please try again later.',
            color: 'danger',
          });
          console.error(err);
        });
    },
  },
  async created() {
    this.getJsonSettings({ slug: this.slug })
      .then((val) => {
        this.JSONData = JSON.stringify(val.data.data, null, 4);
      })
      .catch(() => {
        // A slug with no document yet reads as a 500, so without this the
        // textarea just sits empty and "nothing saved here" is indistinguishable
        // from "the load broke".
        this.JSONData = '';
        this.$vs.notify({
          title: 'No settings found',
          text: `No settings exist yet for "${this.slug}". Saving will create them.`,
          color: 'warning',
        });
      });
  },
};
</script>

<style lang="scss">
.el-input {
  width: 400px;
}
</style>
